import { render, staticRenderFns } from "./PageListContainer.vue?vue&type=template&id=b500b268"
import script from "./PageListContainer.vue?vue&type=script&lang=js"
export * from "./PageListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports